export const getDelta = (
  currentNumberOfUnits: number,
  newNumberOfUnits: number
): number => {
  return newNumberOfUnits > currentNumberOfUnits
    ? newNumberOfUnits - currentNumberOfUnits
    : -(currentNumberOfUnits - newNumberOfUnits);
};
